import type { IAttributes, IDirective, IScope } from "angular";
import { module } from "angular";

import { every, isArray, isNil, isString, some } from "lodash";
import type { IProfileService } from "App/Modules/Auth";
import { Permission } from "App/Modules/Models";

export default class PermissionDirective implements IDirective {
    public restrict = "A";

    public priority = 100;

    public constructor(private readonly profileService: IProfileService) {}

    public link(scope: IScope, instanceElement: JQLite, instanceAttributes: IAttributes) {
        const allowedPermission = scope.$eval(instanceAttributes.irPermission);

        if (!allowedPermission || some(allowedPermission, isNil)) {
            throw new TypeError(`IrPermission: Permission string is missing surounding '' :
            ${instanceAttributes.irPermission}`);
        }

        if (isString(allowedPermission)) {
            const permission = Permission[allowedPermission as keyof typeof Permission];
            if (!permission) {
                throw new TypeError(`IrPermission: Unknown permission :${allowedPermission}`);
            }

            if (!this.profileService.hasPermission(permission)) {
                instanceElement.remove();
            }
        } else if (isArray(allowedPermission)) {
            const notAllowed: boolean = every(
                allowedPermission,
                (p: string) => !this.profileService.hasPermission(Permission[p as keyof typeof Permission]),
            );
            if (notAllowed) {
                instanceElement.remove();
            }
        }
    }
}

module("mmGui").directive("irPermission", [
    "mmProfileService",
    (profileService: IProfileService) => new PermissionDirective(profileService),
]);
